import defaultStrings from '../../components/il8n/locales/en';
import {getLocale, getMessages} from '../../handler/LocaleHandler';

const sleep = async t => new Promise(resolve => setTimeout(resolve, t));

export function fetchTranslations({stringSets}, dispatcher) {
    const request = {
        stringSets: stringSets || []
    }
    executeTranslationRequest(dispatcher, request)
}

function mergeFunction(strings, stringSets) {
    const result = {};
    for (let [key, value] of Object.entries(strings)) {
        stringSets.forEach(stringSet => {
            const [prefix, suffix] = key.split(".");
            if(stringSet === prefix) {
                result[suffix] = value;
            }
        })
    }
    return result;
}

async function executeTranslationRequest(dispatcher, request) {
    await sleep(100);
    const locale = await getLocale();
    dispatcher({
        type: "SET_DATA",
        data: {
            ...mergeFunction(defaultStrings, request.stringSets),
            ...mergeFunction(getMessages(locale), request.stringSets)
        }
    });
}


// WEBPACK FOOTER //
// ./src/commons/api/TranslationAPI.js